/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Obligations_S42_Item_1Inputs */

const es_tyc_obligations_s42_item_1 = /** @type {(inputs: Tyc_Obligations_S42_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intentar evadir, desactivar o sobrepasar las medidas de seguridad de Nexata o Fuentes Conectadas.`)
};

const en_tyc_obligations_s42_item_1 = /** @type {(inputs: Tyc_Obligations_S42_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attempt to evade, disable, or bypass Nexata or Connected Sources security measures.`)
};

/**
* | output |
* | --- |
* | "Attempt to evade, disable, or bypass Nexata or Connected Sources security measures." |
*
* @param {Tyc_Obligations_S42_Item_1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_obligations_s42_item_1 = /** @type {((inputs?: Tyc_Obligations_S42_Item_1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Obligations_S42_Item_1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_obligations_s42_item_1(inputs)
	return en_tyc_obligations_s42_item_1(inputs)
});
export { tyc_obligations_s42_item_1 as "tyc.obligations.s42_item_1" }